import { render, staticRenderFns } from "./productFree.vue?vue&type=template&id=4f4d726e&scoped=true"
import script from "./productFree.vue?vue&type=script&lang=js"
export * from "./productFree.vue?vue&type=script&lang=js"
import style0 from "./productFree.vue?vue&type=style&index=0&id=4f4d726e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4d726e",
  null
  
)

export default component.exports